import * as React from 'react';
const SvgStar = (props) => (
  <svg
    width={17}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_10475_95211)">
      <path
        opacity={0.12}
        d="M9.625 2L10.7811 5.00591C10.9691 5.49473 11.0631 5.73914 11.2093 5.94472C11.3389 6.12693 11.4981 6.28613 11.6803 6.41569C11.8859 6.56187 12.1303 6.65587 12.6191 6.84388L15.625 8L12.6191 9.15612C12.1303 9.34413 11.8859 9.43813 11.6803 9.58431C11.4981 9.71387 11.3389 9.87307 11.2093 10.0553C11.0631 10.2609 10.9691 10.5053 10.7811 10.9941L9.625 14L8.46888 10.9941C8.28087 10.5053 8.18687 10.2609 8.04069 10.0553C7.91113 9.87307 7.75193 9.71387 7.56972 9.58431C7.36414 9.43813 7.11973 9.34413 6.63091 9.15612L3.625 8L6.63091 6.84388C7.11973 6.65587 7.36414 6.56187 7.56972 6.41569C7.75193 6.28613 7.91113 6.12693 8.04069 5.94472C8.18687 5.73914 8.28087 5.49473 8.46888 5.00591L9.625 2Z"
        fill="#605AFB"
      />
      <path
        d="M3.95768 14.6666V11.3333M3.95768 4.66659V1.33325M2.29102 2.99992H5.62435M2.29102 12.9999H5.62435M9.62435 1.99992L8.46823 5.00583C8.28022 5.49465 8.18622 5.73906 8.04003 5.94464C7.91047 6.12685 7.75128 6.28604 7.56907 6.41561C7.36349 6.56179 7.11908 6.65579 6.63026 6.8438L3.62435 7.99992L6.63026 9.15604C7.11908 9.34404 7.36349 9.43805 7.56907 9.58423C7.75128 9.71379 7.91048 9.87299 8.04004 10.0552C8.18622 10.2608 8.28022 10.5052 8.46823 10.994L9.62435 13.9999L10.7805 10.994C10.9685 10.5052 11.0625 10.2608 11.2087 10.0552C11.3382 9.87299 11.4974 9.71379 11.6796 9.58423C11.8852 9.43805 12.1296 9.34404 12.6184 9.15604L15.6243 7.99992L12.6184 6.8438C12.1296 6.65579 11.8852 6.56179 11.6796 6.4156C11.4974 6.28604 11.3382 6.12685 11.2087 5.94464C11.0625 5.73906 10.9685 5.49465 10.7805 5.00583L9.62435 1.99992Z"
        stroke="#605AFB"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_10475_95211">
        <rect
          width={16}
          height={16}
          fill="white"
          transform="translate(0.958008)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStar;
